import startsWith from 'lodash/fp/startsWith';

export const isActive = ({ pathname, to, exclude }) =>
  startsWith(to)(pathname) && (!exclude || !startsWith(exclude)(pathname));
